<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  imgSrc: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  subTitle: {
    type: String,
    required: true
  },
  selected: {
    type: Boolean
  }
});

const emits = defineEmits(['templateClick']);

const onClick = () => {
  emits('templateClick');
};

const selectedBorder = computed(() => props.selected ? `hsl(213, 100%, 48%)` : `rgba(0, 0, 0, 0.12)`);
</script>

<template>
    <div class="template-root" v-ripple @click="onClick">
        <img :src="imgSrc" v-ripple/>
        <h3 class="title">{{ title }}</h3>
        <p class="subtitle">{{ subTitle }}</p>
    </div>
</template>

<style lang="scss" scoped>
@import '../../../assets/variables.module';
.template-root {
    display: flex;
    flex-direction: column;
    padding: 16px 24px;
    max-width: 250px;
    border: 1px solid v-bind(selectedBorder);
    border-radius: 4px;
    cursor: pointer;

    img {
        max-height: 200px;
    }

    .title {
        margin-top: 24px;
        font-size: 16px;
        font-weight: 700;
        text-align: start;
    }

    .subtitle {
        text-align: start;
        line-height: 20px;
        margin-top: 8px;
        color: #575e66;
    }

    &:hover {
        border-color: $primary-color;
    }
}
</style>
